var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{staticClass:"view view--calendar",attrs:{"id":"dayspan"}},[_c('ds-calendar-app',{attrs:{"calendar":_vm.calendar},on:{"actioned":_vm.handleAction,"event-create":_vm.handleSubmit,"event-remove":_vm.handleRemove,"event-update":_vm.handleSubmit}}),_vm._v(" "),_c('task-list')],1)}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-33e56ce3","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/views/calendar/Index.vue
// module id = E7Bi
// module chunks = 0